import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/images/logo.webp';
import drawerIcon from '../../assets/icons/drawer.png';
import xmarkIcon from '../../assets/icons/xmark.png';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const menuItems = [
    { name: 'Home', path: '/' },
    {
      name: 'Locations',
      dropdown: [
        { name: 'Sydney Office', path: '/location-sydney' },
        { name: 'Regional Office', path: '/location-orange' },
        { name: 'India Office', path: '/location-mohali' },
      ],
    },
    { name: 'Individual Tax Return', path: '/individual-tax-return' },
    { name: 'Accounting Services', path: '/accounting-services' },
    { name: 'About', path: '/about' },
  ];

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <header className='header'>
      <div className='header-container'>
        <div className='header-content'>
          <div className='logo-container'>
            <Link to='/'>
              <img src={logo} alt='Progressive Financial' className='logo' />
            </Link>
          </div>

          <nav className='navigation'>
            <ul className='nav-menu'>
              {menuItems.map((item, index) => (
                <li key={index} className={`nav-item ${item.dropdown ? 'dropdown' : ''}`}>
                  {item.dropdown ? (
                    <div className='dropdown-container'>
                      <span className='nav-link dropdown-trigger'>{item.name}</span>
                      <ul className='dropdown-menu'>
                        {item.dropdown.map((dropdownItem, dropdownIndex) => (
                          <li key={dropdownIndex} className='dropdown-item'>
                            <Link to={dropdownItem.path} className={`dropdown-link ${location.pathname === dropdownItem.path ? 'active' : ''}`}>
                              {dropdownItem.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    <Link to={item.path} className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}>
                      {item.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          <div className='header-button-container'>
            <Link to='/contact' className='btn btn-hero-primary'>
              Contact Us
            </Link>
          </div>

          {/* Mobile Drawer Button */}
          <button className='drawer-toggle' onClick={toggleDrawer}>
            <img src={drawerIcon} alt='Menu' />
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      {isDrawerOpen && (
        <div className='drawer-overlay' onClick={closeDrawer}>
          <div className='drawer' onClick={(e) => e.stopPropagation()}>
            <div className='drawer-header'>
              <img src={logo} alt='Progressive Financial' className='drawer-logo' />
              <button className='drawer-close' onClick={closeDrawer}>
                <img src={xmarkIcon} alt='Close' />
              </button>
            </div>
            <nav className='drawer-nav'>
              {menuItems.map((item, index) =>
                item.dropdown ? (
                  <div key={index} className='drawer-dropdown'>
                    <span className='drawer-nav-link dropdown-title'>{item.name}</span>
                    {item.dropdown.map((dropdownItem, dropdownIndex) => (
                      <Link
                        key={dropdownIndex}
                        to={dropdownItem.path}
                        className={`drawer-nav-link dropdown-item ${location.pathname === dropdownItem.path ? 'active' : ''}`}
                        onClick={closeDrawer}
                      >
                        {dropdownItem.name}
                      </Link>
                    ))}
                  </div>
                ) : (
                  <Link
                    key={index}
                    to={item.path}
                    className={`drawer-nav-link ${location.pathname === item.path ? 'active' : ''}`}
                    onClick={closeDrawer}
                  >
                    {item.name}
                  </Link>
                )
              )}
            </nav>
            <div className='drawer-footer'>
              <p>© 2025 PFGS. All rights reserved.</p>
              <div className='drawer-social'>
                <a href='https://www.facebook.com/profile.php?id=61578288867434' className='social-link'>
                  <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
                    <path
                      d='M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z'
                      fill='currentColor'
                    />
                  </svg>
                </a>
                <a href='#' className='social-link'>
                  <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
                    <path
                      d='M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z'
                      fill='currentColor'
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
